import { Inject, Injectable } from '@angular/core';
import { CORE_API_ROUTES } from '@app/core/configs/api-routes';
import { HttpService } from '@app/core/services/http.service';
import { Observable } from 'rxjs';
import { IPermission, PermissionType } from '../models/permission';

@Injectable()
export class PermissionService {
  constructor(@Inject(CORE_API_ROUTES) private apis, private httpService: HttpService) {}

  getAllPermissions$(): Observable<IPermission[]> {
    return this.httpService.get<IPermission[]>(this.apis.permission.permissions);
  }

  addPermission$(newPermit: IPermission): Observable<boolean> {
    return this.httpService.put<boolean>(this.apis.permission.permission, newPermit);
  }

  deletePermission$(permissionId: PermissionType): Observable<boolean> {
    return this.httpService.delete<boolean>(this.apis.permission.id(permissionId));
  }
}
